import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KButtonType } from 'ng-k-button';
import { IKCard, KCardFieldType } from 'ng-k-card';
import { ClaimsService } from 'src/app/services/claims.service';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import * as moment from 'moment';
import { KIconType } from 'ng-k-icon';
import { KInputType } from 'ng-k-form';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { AsbestosRadiologicalProgressionService } from 'src/app/services/asbestos-radiological-progression.service';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-radiological-progression-mesothelioma',
  templateUrl: './radiological-progression-mesothelioma.component.html',
  styleUrls: ['./radiological-progression-mesothelioma.component.scss']
})
export class RadiologicalProgressionMesotheliomaComponent implements OnInit {
  public claimId: any;
  public radProgId: any;
  KButtonType = KButtonType;
  public claimInfo: IKCard = {};
  public claimInfo2: IKCard = {};
  public claimData: any = [];
  public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public successText!: string;
  public errorText!: string;
  public timeout!: number;
  public measurementTypes: {label: string, value: any}[]= [];
  public radiologicalProgFibrosisOptions: {label: string, value: any}[]= [];
  public radiologicalProgPlaquesOptions: {label: string, value: any}[]= []; 
  public radiologicalProgThickeningOptions: {label: string, value: any}[]= []; 
  public exerciseToleranceOptions: {label: string, value: any}[]= []; 
  public measurementList : any = [];

  public dynamicNumberInput: any = KInputType['number'];
  public dynamicDateInput: any = KInputType['datepicker'];
  public dynamicStringInput: any = KInputType['string'];

  radiologicalProgressionForm: FormGroup;
  public heightMeasurement: any = {};
  public heightError: any = [];
  public errorList: any = [];
  public disableSaveButton: boolean = false;
  public viewExerciseToleranceAccordionDiv: boolean = false;
  public maxDate = new Date();
  public customData: any;

  constructor(
    private router:Router,
    private route: ActivatedRoute,
    private loaderService: GlobalLoadingService,
    private claimsService: ClaimsService,
    private asbestosRadProgService: AsbestosRadiologicalProgressionService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.claimId = decodeURIComponent(params['claimId']);
      this.radProgId = params['radProgressionId'] ? decodeURIComponent(params['radProgressionId']) : '';
    });
    this.getWorkflowOverview(this.claimId);
    this.getMeasurementTypes();
    this.getMeasurementList();

    this.getRadioProgFibrosisOptions();
    this.getRadioProgPlaquesOptions();
    this.getRadioProgThickeningOptions();
    this.getExerciseToleranceOptions();
  }

  goToPage() {
    this.router.navigate(['/claimDetail/', this.claimId, 'medical']);
  }

  // Use an object to store the collapse state of each panel
  panelStates: { [key: string]: boolean } = {};
  // This method is called when a panel state changes
  onPanelChange(event: NgbPanelChangeEvent) {
    const panelId = event.panelId;
    const nextState = event.nextState;
    // Update the collapse state dynamically based on the panelId
    this.panelStates[panelId] = nextState;
  }

  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');
        this.claimData = result.data.meta;
        this.customData = {
          claimId : this.claimId,
          claimantName : this.claimData.claimant.claimantName,
          medicalConditionLabel: 'Mesothelioma',
          medicalConditionValue: 'mesothelioma'
        }
        this.getClaimInfo(this.claimId);
      }
    },
    err => {
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('getWorkflowOverview');
      if (err.error.status === 'Unprocessable') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');
        this.claimData = [];
        this.errorText = err.error.Message;
        this.showMessage('error', 2000);
        setTimeout(() => {
          this.displayError = false;
        }, 2010);
      }
    });
  }

  public getClaimInfo(claimID: any) {
    this.loaderService.startLoadingIndicator('getClaimInfo');
    this.claimInfo = {
      value: '',
      header: {
        label: moment(new Date(this.claimData.claim.createdDate)).format('DD/MM/YYYY'),
        labelColour: 'brand-main',
        icon: {
          type: KIconType.fas,
          name: 'clock'
        }
      },
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Reference',
          value: this.claimData?.claimant?.claimReference ? this.claimData?.claimant?.claimReference : ' ',
          icon: {
            type: KIconType.fas,
            name: 'tag',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Claimant Name',
          value: this.claimData.claimant.claimantName,
          icon: {
            type: KIconType.fas,
            name: 'user',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Condition',
          value: this.claimData.claimant.condition,
          icon: {
            type: KIconType.fas,
            name: 'stethoscope',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Open >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    let amountSymbol = ''

    this.claimInfo2 = {
      value: '',
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Amount',
          value: this.claimData.claim.claimAmount != 0 ? this.claimData.claim.claimAmount : '0',
          icon: {
            type: KIconType.fas,
            name: 'wallet',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'No. of Defendants',
          value: this.claimData.claim.noOfDefendants ? this.claimData.claim.noOfDefendants : ' ',
          icon: {
            type: KIconType.kennedys,
            name: 'defendant',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'No. of Insurers',
          value: this.claimData.claim.insurersInfo.value + ' Insurer(s)',
          icon: {
            type: KIconType.kennedys,
            name: 'insurer',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: this.claimData.claim.employersInfo.type == 'name' ? 'Employer name' : 'No. of Employers',
          value: this.claimData.claim.employersInfo.type == 'name' ? (this.claimData.claim.employersInfo.value) : (this.claimData.claim.employersInfo.value + ' Employer(s)'),
          icon: {
            type: KIconType.fas,
            name: 'user-tie',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Full Apportionment >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    this.loaderService.stopLoadingIndicator('getClaimInfo');
  }

  public getMeasurementTypes() {
    let tempList = ['Weight','Radiological Progression (Fibrosis)','Radiological Progression (Thickening)',
      'Radiological Progression (Plaques)','Forced Vital Capacity (FVC)','Forced Expiratory Volume in 1 Second (FEV1)','Exercise Tolerance'];
    for(let temp of tempList) {
      this.measurementTypes.push({label: temp, value: temp });
    }
  }
  
  public getRadioProgFibrosisOptions() {
    this.radiologicalProgFibrosisOptions = [];
    let tempList =  ['Significant Improvement', 'Medium Improvement', 'Minor Improvement', 'None', 'Minor', 'Medium', 'Significant'];
    for(let temp of tempList) {
      this.radiologicalProgFibrosisOptions.push({label: temp, value: temp });
    }
  }

  public getRadioProgPlaquesOptions() {
    this.radiologicalProgPlaquesOptions = [];
    let tempList =  ['None', 'Minor', 'Medium', 'Significant'];
    for(let temp of tempList) {
      this.radiologicalProgPlaquesOptions.push({label: temp, value: temp });
    }
  }

  public getRadioProgThickeningOptions() {
    this.radiologicalProgThickeningOptions = [];
    let tempList =  ['None', 'Minor', 'Medium', 'Significant'];
    for(let temp of tempList) {
      this.radiologicalProgThickeningOptions.push({label: temp, value: temp });
    }
  }

  public getExerciseToleranceOptions() {
    this.exerciseToleranceOptions = [];
    let tempList =  ['0%', '10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'];
    for(let temp of tempList) {
      this.exerciseToleranceOptions.push({label: temp, value: temp });
    }
  }

  public getMeasurementList() {
    if(this.radProgId != '') {
      this.disableSaveButton = false;
      this.loaderService.startLoadingIndicator('getMeasurementList');
      const thisObj = this;
      const requestParam: any = {};
      requestParam.claimId = this.claimId ? this.claimId : null;
      requestParam.id = this.radProgId ? this.radProgId : '';

      thisObj.asbestosRadProgService.retrieveRadiologicalProgression(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('getMeasurementList');
          this.measurementList = result.data.measurements;
          if (this.measurementList.length == 0) {
            this.addNewMeasurement();
          }
          this.heightMeasurement = result.data.height ? result.data.height : '';
          for (let measurement of this.measurementList) {
            let tempDate = measurement.values.date;
            measurement.values.date = new Date(tempDate)

            if (measurement.type == 'Radiological Progression (Fibrosis)') {
              // this.onFormChange(measurement.type, index: number, selectedElement: any) {
            }
          }

          this.measurementList.forEach((measurement: any, index: any) => {
            if (measurement.type == 'Radiological Progression (Fibrosis)' || measurement.type == 'Radiological Progression (Thickening)'
               || measurement.type == 'Radiological Progression (Plaques)' || measurement.type == 'Exercise Tolerance') {
              let tempValue = measurement.values.value;
              this.onFormChange( index, 'Measurement',null, measurement.type)
              this.onFormChange(index, 'Value', null, tempValue)
              this.viewExerciseToleranceAccordionDiv = false;
            }
          });
        }
      }, err => {
        this.loaderService.stopLoadingIndicator('getMeasurementList');
      });
    }
    // this.measurementList = [
      // {
      //   type: "WEIGHT",
      //   values: {
      //       measurement: 'WEIGHT',
      //       value: "20",
      //       date: new Date('2025-01-08T09:23:15.166Z')
      //   }
      // },
    
    if (this.measurementList.length == 0) {
      this.addNewMeasurement();
    }
  }

  public saveMeasurements() {
    if(Object.keys(this.heightMeasurement).length == 0) {
      this.heightError = {
        message: 'Height is mandatory'
      };
    }
    if ((Object.keys(this.heightError).length != 0) ) {
      // console.log(this.heightError)
      // console.log(this.errorList)
    } else 
    if ((Object.keys(this.measurementList).length === 1)) {
      if ((this.measurementList[0].type === '') && (this.measurementList[0].values.value === '')) {
        this.measurementList = [];
        this.addNewMeasurement();
        this.errorText = 'No measurements added.';
        this.showMessage('error', 2000);
        setTimeout(() => {
          this.displayError = false;
        }, 2010);
      } else
      if (this.measurementList[0].values.value === '') {
        // console.log('7788')
        this.validateValueAgainstSelectedMeasurement(this.measurementList[0].type, this.measurementList[0].values.value, 0);
      } else 
      {
        // console.log('778');
        // console.log(this.measurementList[0].valueErrors?.message ? this.measurementList[0].valueErrors.message : 'VV')
        if (this.measurementList[0].valueErrors?.message || this.measurementList[0].dateErrors?.message) {
        } else {
          this.saveData();
        }
        
      }
    } else 
    if (this.measurementList.length === 0){
      this.measurementList = [];
      this.addNewMeasurement();
      this.errorText = 'No measurements added.';
      this.showMessage('error', 2000);
      setTimeout(() => {
        this.displayError = false;
      }, 2010);
    } else 
    if (this.measurementList.length > 0) {
      this.validateMeasurementList();
      // console.log('errorList : ' + this.errorList)
      if (this.errorList.length > 0 ) {
        for (let i of this.errorList) {
          // console.log(i)
        }
        
      } else { 
        this.measurementList.forEach((measurement: any, index: any) => {
          // console.log(measurement)
          if(measurement.valueErrors.message) {
              let temp = {
                key: index,
                valueMessage: 'Incorrect measurement value'
              }
              this.errorList.push(temp);
          }
        });
        if (this.errorList.length == 0) {
          // console.log(this.errorList.length)
          this.saveData();
        } else {
          // console.log(this.errorList.length)
        }
      }
    } else { 
      // this.saveData();
    }
  }

  public validateMeasurementList() {
    this.errorList = [];
    for (const [key, value] of Object.entries(this.measurementList)) {
      // console.log("KEY : " +key)
      if ( this.measurementList[key].type == '' ) {    
        this.measurementList[key].measurementErrors.message = "Measurement type cannot be empty";
          let temp = {
            key: key,
            measurementMessage: 'Measurement type cannot be empty'
          }
          this.errorList.push(temp);   
      } else {
        // console.log('type not empty')

        const indexToRemove = this.errorList.findIndex((item: { key: String; measurementMessage: String }) => item.key === key  && 
        item.measurementMessage === 'Measurement type cannot be empty');

        if (indexToRemove !== -1) {
          // Splice the item from the array at that index
          this.errorList.splice(indexToRemove, 1);
        }

        // console.log(this.errorList)

      }

      if (this.measurementList[key].values.value == '') {
        let temp = {
          key: key,
          valueMessage: 'Measurement value cannot be empty'
        }
        this.errorList.push(temp);
        this.validateValueAgainstSelectedMeasurement(this.measurementList[key].type, this.measurementList[key].values.value, key);
      } else {
        // console.log('value not empty')

        const indexToRemove = this.errorList.findIndex((item: { key: String; valueMessage: String }) => item.key === key  && 
        item.valueMessage === 'Measurement value cannot be empty');

        if (indexToRemove !== -1) {
          // Splice the item from the array at that index
          this.errorList.splice(indexToRemove, 1);
        }
        this.validateValueAgainstSelectedMeasurement(this.measurementList[key].type, this.measurementList[key].values.value, key);
        // if (this.measurementList[key])
        // console.log(this.measurementList[key])
        // console.log(this.errorList)
      }

      if (this.measurementList[key].dateErrors?.message) {
        let temp = {
          key: key,
          dateMessage: 'Incorrect date entered'
        }
        this.errorList.push(temp);
      } else {
        const indexToRemove = this.errorList.findIndex((item: { key: String; dateMessage: String }) => item.key === key  && 
        item.dateMessage === 'Incorrect date entered');

        if (indexToRemove !== -1) {
          // Splice the item from the array at that index
          this.errorList.splice(indexToRemove, 1);
        }
      }
    }
  }

  public saveData() {
    for (let measurement of this.measurementList) {
      if(!measurement.key) {
       measurement['key'] = this.formatUserValue(measurement.type)
      }
    }
    this.disableSaveButton = true;
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.id = this.radProgId ? this.radProgId : '';
    requestParam.height = this.heightMeasurement;
    requestParam.measurements=this.measurementList;
    this.loaderService.startLoadingIndicator('saveData');
    thisObj.asbestosRadProgService.saveRadiologicalProgression(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('saveData');
        this.successText = "Saved measurements successfully";
        this.showMessage('success', 2000);
        setTimeout(() => {
          this.router.navigate([`mesothelioma/radiological-progression/view-chart/`, this.claimId, result.data._id, result.data.title]);
        }, 2010);
      }
    }, err => {
      this.loaderService.stopLoadingIndicator('saveData');
    });
  }

  public onHeightChange(event: Event) {
    const heightValue: any = (event.target as HTMLInputElement).value;
    if (heightValue < 100 || heightValue > 250) {
      this.heightError = {
        message: 'Height should be minimum 100 cms and maximum 250 cms'
      };
      this.disableSaveButton = true;
      this.errorText = this.heightError.message;
      this.showMessage('error', 2000);
      setTimeout(() => {
        this.displayError = false;
      }, 2010);
    } else
    if (heightValue >= 100 || heightValue <= 250) {
      this.heightError = [];
      this.disableSaveButton = false;
      this.heightMeasurement = {
        value : heightValue,
        unit: "cm"
      }
    }
  }

  public formatUserValue(value: any) {
    let modifiedString  = value
     .toLowerCase()
     .replace(/\s+/g, '_') // Replace spaces with underscores
     .replace(/[()]/g, '') // Remove parentheses
     .replace(/[^a-z0-9_]/g, ''); // Remove special characters
   return modifiedString;
   }

  public onFormChange( index: number, selectedElement: any, event ? : any, manualValue? : any ) {
    let userValue = '';
    if (event) {
      userValue = (event.target as HTMLInputElement).value ;
    } else 
    {
      userValue = manualValue
    }
    // this.measurementList[index].type = value;

    const availableElements= ['Measurement', 'Value', 'Date'];
    let type: string | undefined;
    let value: number | undefined;
    let date: string | undefined;

    if (availableElements.includes(selectedElement)) {
            switch (selectedElement) {
        case 'Measurement':
          this.viewExerciseToleranceAccordionDiv = false;
          this.measurementList[index].values.value = '';
          this.measurementList[index].type = userValue;
          this.measurementList[index].key = this.formatUserValue(userValue);
          this.measurementList[index].valueErrors = {};
          const foundItem = this.measurementTypes.find(item => item.value === userValue);
          if (foundItem) { this.measurementList[index].measurementErrors = {};
            switch (userValue) {
              case 'Weight':
                this.measurementList[index].values.measurement = 'Value (Kg)';
                this.measurementList[index].values.valueDisplayType = 'textField';
                break;
              case 'Forced Vital Capacity (FVC)':
                this.measurementList[index].values.measurement = 'Value (Lt)';
                this.measurementList[index].values.valueDisplayType = 'textField';
                break;
              case 'Forced Expiratory Volume in 1 Second (FEV1)':
                this.measurementList[index].values.measurement = 'Value (Lt)';
                this.measurementList[index].values.valueDisplayType = 'textField';
                break;
              case 'Exercise Tolerance':
                this.viewExerciseToleranceAccordionDiv = true;
                this.measurementList[index].values.measurement = 'Value (%)';
                this.measurementList[index].values.valueDisplayType = 'dropdown';
                break;
              case 'Radiological Progression (Fibrosis)':
                this.measurementList[index].values.measurement = 'Value';
                this.measurementList[index].values.valueDisplayType = 'dropdown';
                break;
              case 'Radiological Progression (Plaques)':
                this.measurementList[index].values.measurement = 'Value';
                this.measurementList[index].values.valueDisplayType = 'dropdown';
                break;
              case 'Radiological Progression (Thickening)':
                this.measurementList[index].values.measurement = 'Value';
                this.measurementList[index].values.valueDisplayType = 'dropdown';
                break;
              default:
                this.measurementList[index].values.measurement = ''; // Default case if no match found
            }
          }
          break;
        case 'Value':
          this.measurementList[index].values.value = userValue;
          // console.log(this.measurementList[index].type)
          this.validateValueAgainstSelectedMeasurement(this.measurementList[index].type, this.measurementList[index].values.value, index);
          break;
        case 'Date':
          this.validateDate(userValue, index)
          
          break;
        default:
          break;
      }
    };
  }

  public validateDate(dateString: any, index: any) {
    const pattern = "DD/MM/YYYY"; // Moment-compatible pattern

    const isValidDate = (dateString: string): boolean => {
      // Regex to check DD/MM/YYYY format
      const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (!dateRegex.test(dateString)) {
        return false; // Format doesn't match
      }
    
      const [day, month, year] = dateString.split('/').map(Number);
    
      // Check for valid ranges of day, month, and year
      if (month < 1 || month > 12) return false; // Invalid month
      if (day < 1 || day > 31) return false; // Invalid day
      if (year < 1000 || year > 9999) return false; // Invalid year
    
      // Check if the date is valid using the Date object
      const dateObject = new Date(year, month - 1, day);
      return (
        dateObject.getFullYear() === year &&
        dateObject.getMonth() === month - 1 &&
        dateObject.getDate() === day
      );
    };

    const convertToISO8601 = (dateString: string): string | null => {
      if (!isValidDate(dateString)) {
        console.error("Invalid date format or value!");
        return null;
      }
    
      const [day, month, year] = dateString.split('/').map(Number);
      const dateObject = new Date(Date.UTC(year, month - 1, day));
      return dateObject.toISOString();
    };
    const isoDate = convertToISO8601(dateString);
    
    if (!isoDate) {
      // console.log('invalid date : ' + dateString)
      this.errorText = 'Please enter a valid date';
      this.showMessage('error', 2000);
      setTimeout(() => {
        this.displayError = false;
      }, 2010);
      // this.disableSaveButton = true;

      let tempError = {
        message : "Invalid date",
        type: "Date"
      }

      if(this.measurementList[index].dateErrors && Object.keys(this.measurementList[index].dateErrors). length>0) {
        // console.log('not empty');
        if ((this.measurementList[index].dateErrors.message === tempError.message) && (this.measurementList[index].dateErrors.type ===tempError.type)) {
          
            } else {
              this.measurementList[index].dateErrors.push(tempError)
              // this.disableSaveButton = true;
            }
      } else {
        // console.log('empty')
        this.measurementList[index].dateErrors = tempError;
        // this.disableSaveButton = true;
        this.errorText = tempError.message;
        this.showMessage('error', 2000);
        setTimeout(() => {
          this.displayError = false;
        }, 2010);
      }
      return false; // Invalid format
    } else {
      if (this.checkIfFutureDate(isoDate)) {
        this.disableSaveButton = false;
        let tempError = {
          message: 'Invalid Date',
          type: 'Date'
        }
        this.measurementList[index].dateErrors = tempError;
        this.errorText = tempError.message;
        this.showMessage('error',2000);
        setTimeout(() => {
          this.displayError = false;
        }, 2010);
      } else {
        this.measurementList[index].dateErrors = {};
        this.measurementList[index].values.date = new Date(isoDate);
        this.disableSaveButton = false;
      }
      return true
    }
  
    // Extract the year and validate it's in the 1900s
    const year = moment(dateString, pattern).year();
    // console.log(year)
    return year >= 1900 && year < 2000; // Adjust range as needed
  }

  public checkIfFutureDate(isoDate: string): boolean {
    const inputDate = new Date(isoDate);
    const currentDate = new Date();
    return inputDate > currentDate;
  }

  public positiveNumValidation(value: string): boolean {
      const regex = /^[+]?\d+(\.\d)?$/;
      return regex.test(value);
  }

  public validateAndAddError(index: any, tempError: any) {
    if(this.measurementList[index].valueErrors && Object.keys(this.measurementList[index].valueErrors). length>0) {
      // console.log('not empty');
      if ((this.measurementList[index].valueErrors.message === tempError.message) && (this.measurementList[index].valueErrors.type ===tempError.type)) {
        
          } else {
            this.measurementList[index].valueErrors.push(tempError)
            // this.disableSaveButton = true;
          }
    } else {
      // console.log('empty')
      this.measurementList[index].valueErrors = tempError;
      // this.disableSaveButton = true;
      this.errorText = tempError.message;
      this.showMessage('error', 2000);
      setTimeout(() => {
        this.displayError = false;
      }, 2010);
    }
  }

  public validateValueAgainstSelectedMeasurement(measurementType: any, measurementValue: any, index: any) {
    switch (measurementType) {
      case 'Weight':
        if (measurementValue < 20 || measurementValue > 200) {
          let tempError = {
            message: 'Weight should be within 20 Kg and 200 Kg',
            type: 'weight'
          }
          this.validateAndAddError(index, tempError);
        } else
        if (measurementValue == '') {
          let tempError = {
            message: 'Weight cannot be empty',
            type: 'weight'
          }
          this.validateAndAddError(index, tempError);
        } else 
        {
          this.measurementList[index].valueErrors = {};
          this.disableSaveButton = false;
        }
        break;
      case 'Forced Vital Capacity (FVC)':
        if (measurementValue >=0 && measurementValue <=10)  {
          this.measurementList[index].valueErrors = {};
          this.disableSaveButton = false;
        } else {
          this.measurementList[index].valueErrors = {};
          this.disableSaveButton = false;
          if (measurementValue < 0 || measurementValue > 10) {
            let tempError = {
              message: 'Positive numbers between 0 and 10 are allowed, with a maximum of two decimal places.',
              type: 'FVC'
            }
            this.validateAndAddError(index, tempError)
          }
        }
        break;
      case 'Forced Expiratory Volume in 1 Second (FEV1)':
        if (measurementValue >=0 && measurementValue <=10)  {
          this.measurementList[index].valueErrors = {};
          this.disableSaveButton = false;
        } else {
          this.measurementList[index].valueErrors = {};
          this.disableSaveButton = false;
          if (measurementValue < 0 || measurementValue > 10) {
            let tempError = {
              message: 'Positive numbers between 0 and 10 are allowed, with a maximum of two decimal places.',
              type: 'FEV1'
            }
            this.validateAndAddError(index, tempError)
          }
        }
        break;
      case 'Exercise Tolerance':
        if (measurementValue == '') {
          let tempError = {
            message: 'Select a value',
            type: 'ExerciseTolerance'
          }
          this.validateAndAddError(index, tempError);
        } else 
        {
          this.measurementList[index].valueErrors = {};
        }
        break;
      case 'Radiological Progression (Fibrosis)':
        if (measurementValue == '') {
          let tempError = {
            message: 'Select a value',
            type: 'Fibrosis'
          }
          this.validateAndAddError(index, tempError);
        } else 
        {
          this.measurementList[index].valueErrors = {};
        }
        break;
      case 'Radiological Progression (Plaques)':
        if (measurementValue == '') {
          let tempError = {
            message: 'Select a value',
            type: 'Plaques'
          }
          this.validateAndAddError(index, tempError);
        } else 
        {
          this.measurementList[index].valueErrors = {};
        }
        break;
      case 'Radiological Progression (Thickening)':
        if (measurementValue == '') {
          let tempError = {
            message: 'Select a value',
            type: 'Thickening'
          }
          this.validateAndAddError(index, tempError);
        } else 
        {
          this.measurementList[index].valueErrors = {};
        }
        break;
      default:
        
    }
    // console.log(this.measurementList[index])
  }

  public removeErrorFromList(measurementType: any) {
    // Find the index of the item with the message you want to remove
    const indexToRemove = this.errorList.findIndex((item: { type: string; }) => item.type === measurementType);

    if (indexToRemove !== -1) {
      // Splice the item from the array at that index
      this.errorList.splice(indexToRemove, 1);
    }
  }

  public  addNewMeasurement() {
    let temp = 
      {
        type: "",
        key: "",
        values: {
            measurement: '',
            value: "",
            valueDisplayType: "",
            date: new Date()
        },
        valueErrors:{},
        dateErrors: {},
        measurementErrors: {}
      }
    this.measurementList.push(temp);
  }

  public copyMeasurement(indexNum: number) {
    const newRow = JSON.parse(JSON.stringify(this.measurementList[indexNum]));  // deep copy
    const tempDate = new Date(newRow.values.date);
    newRow.values.date = tempDate;
    this.measurementList.push(newRow);
  }

  public deleteMeasurement(indexNum: number) {
    this.viewExerciseToleranceAccordionDiv = false;
    this.measurementList.splice(indexNum, 1)

    // console.log(this.measurementList)
  }

  public preventEnter(event: Event) {
    event.preventDefault();
    // console.log('Enter key press is prevented')
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    this.displayError = false;
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }
}
